export default __webpack_public_path__ + "static/media/sarath-headshot.3ef13474.jpg";